<template>
  <div class="ExempleButton" @click="onClick()"> 
    <div ref="container" class="ExempleButton__container" :class="{ 'use-shadow': use_shadow}">
      <div ref="txt" class="ExempleButton__txt">{{ trans('GLOBAL.'+ indice) }}</div>
      <div ref="icon" class="ExempleButton__icon"> 
        <svg viewBox="0 0 68.68 64.57" v-if="indice == 'read'">
          <path class="cls-1" d="M7.1,14.59A7.1,7.1,0,0,0,0,21.69H23.58V64.57a7.1,7.1,0,0,0,7.1-7.1V14.59Z"/>
          <path class="cls-1" d="M38,64.57h.12a7,7,0,0,0,7-7V7.1H68.68A7.1,7.1,0,0,0,61.57,0H38Z"/>
          <path class="cls-1" d="M61.57,14.59H52.16v7.1H68.68A7.1,7.1,0,0,0,61.57,14.59Z"/>
          <path class="cls-1" d="M0,7.1H30.68V0H7.1A7.1,7.1,0,0,0,0,7.1Z"/>
        </svg>
        <svg  viewBox="0 0 68.94 76.9" v-if="indice == 'hear'">
          <path class="cls-1" d="M30.83,0H31a7.15,7.15,0,0,1,7.15,7.15V76.9a0,0,0,0,1,0,0H38a7.15,7.15,0,0,1-7.15-7.15V0a0,0,0,0,1,0,0Z"/>
          <path class="cls-1" d="M22.57,11.14h.13a0,0,0,0,1,0,0V58.6a7.15,7.15,0,0,1-7.15,7.15h-.13a0,0,0,0,1,0,0V18.3a7.15,7.15,0,0,1,7.15-7.15Z"/>
          <path class="cls-1" d="M53.4,11.14h.13a0,0,0,0,1,0,0V58.6a7.15,7.15,0,0,1-7.15,7.15h-.13a0,0,0,0,1,0,0V18.3a7.15,7.15,0,0,1,7.15-7.15Z"/>
          <path class="cls-1" d="M61.66,26.75h.13a7.15,7.15,0,0,1,7.15,7.15V50.15a0,0,0,0,1,0,0h-.13A7.15,7.15,0,0,1,61.66,43V26.75A0,0,0,0,1,61.66,26.75Z"/>
          <path class="cls-1" d="M0,26.75H.13A7.15,7.15,0,0,1,7.28,33.9V50.15a0,0,0,0,1,0,0H7.15A7.15,7.15,0,0,1,0,43V26.75a0,0,0,0,1,0,0Z"/>
        </svg>
      </div>
    </div>
  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'ExempleButton',
  props: ['indice'],
  data: ()=>({
    use_shadow: false,
    inc: 0
  }),


  beforeDestroy() {
    cancelAnimationFrame(this.raf);
  },

  mounted() { 
    gsap.from([ this.$refs.container, this.$refs.txt, this.$refs.icon ], {
        duration: .35, 
          x: '+=20%', 
          ease: 'cubic.out', 
          opacity: 0,
          stagger: .2,
          delay: 1.25, 

    })

    this.raf = requestAnimationFrame(this.loop)
    
  },

  methods:{
    loop() {
      this.raf = requestAnimationFrame(this.loop)
      this.inc += 1
      if(this.inc == 150){
        this.inc = 0
        this.use_shadow = !this.use_shadow
        // window.alert('x')
      }
    },
    onClick() {
      this.$parent.use_exemple = true
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.ExempleButton
  position absolute
  top 0px
  right 0px
  display flex
  align-items center
  padding 22px
  color white
  transition opacity .35s
  opacity 1

  &__container
    display flex
    align-items center
    height auto
    background purple
    padding 8px 24px
    border-radius 16px
    transition box-shadow 2s ease-in-out

    &.use-shadow
      box-shadow 0px 0px 20px 1px rgba(255,255,194,0.5)

  &__icon 
    width 2.8vh
    height 2.8vh

  &__txt 
    padding-right 12px

  .cls-1
    fill #fff

</style>


